/**
 * OTP Agrár Nyeremény játék Service
 *
 * @author Erik Bánhalmi @2017.01.12.
 */
import 'angular-uuid';
const MODULE_NAME = 'nyeremenyjatekService';
class NyeremenyjatekService {
	constructor($http, environment, $q, uuid) {
		'ngInject';
		this._$http = $http;
		this._$q = $q;
		this._apiRoot = `${environment.backendUrl}/do/proxy/b`;
		this._environment = environment;
		this._uuid = uuid;
	}
	getCaptchaUrl() {
		this._captchaId = this._uuid();
		return `${this._environment.captchaUrl}/${this._captchaId}?appid=otpagrar`;
	}
	subscribe(object, captcha) {
		let headers = {
			'x-captcha-id': this._captchaId,
			'x-captcha-value': captcha
		};
		return this._$http({
			method: 'POST',
			url: `${this._apiRoot}/otpagrar-backend/nyeremenyjatek`,
			data: object ? object : {},
			headers: headers
		});
	}
	submitQuiz(object) {
		return this._$http({
			method: 'POST',
			url: `${this._apiRoot}/otpagrar-backend/nyeremenyjatek/finish`,
			data: object ? object : {}
		});
	}

}

export default angular.module(MODULE_NAME, ['angular-uuid'])
	.service('nyeremenyjatekService', NyeremenyjatekService).name;



// WEBPACK FOOTER //
// ./source/applications/nyeremenyjatek/nyeremenyjatek-service.js